module.exports = __webpack_public_path__ + "static/media/sort-circle-up.f61a84a0.svg";